import {Link, NavLink} from "react-router-dom";
import s from './breadcrumbs.module.css'
import useBreadcrumbs from 'use-react-router-breadcrumbs';

const Breadcrumbs = (props) => {

    const routes = [
        {path: '/', breadcrumb: 'Главная'},
        {path: '/categories', breadcrumb: 'Категории'},
        {path: '/brands', breadcrumb: 'Производитель'},
        {path: '/info', breadcrumb: 'О нас'},
        {path: '/delivery', breadcrumb: 'Доставка'},
        {path: '/security', breadcrumb: 'Политика безопасности'},
        {path: '/news', breadcrumb: 'Новости'},
        {path: '/news/:new', breadcrumb: props.title},
        {path: '/account', breadcrumb: 'Личный кабинет'},
        {path: '/basket', breadcrumb: 'Корзина'},
        {path: '/contacts', breadcrumb: 'Связаться с нами'},
        {path: '/basket/order-checkout', breadcrumb: 'Оформить заказ'},
        {path: '/basket/success', breadcrumb: 'Заказ оформлен успешно'},
        {path: '/account/login', breadcrumb: 'Войти'},
        {path: '/account/registration', breadcrumb: 'Регистрация'},
        {path: '/account/reset-password', breadcrumb: 'Забыли пароль?'},
        {path: '/account/address', breadcrumb: 'Адрес'},
        {path: '/account/edit-profile', breadcrumb: 'Редактировать профиль'},
        {path: '/account/orders', breadcrumb: 'История заказов'},
        {path: '/account/liked', breadcrumb: 'Закладки'},
        {path: '/account/change-password', breadcrumb: 'Изменить пароль'},
        {path: 'categories/:category', breadcrumb: props.title},
        {path: 'categories/:category/:id', breadcrumb: props.name},
    ]


    const breadcrumbs = useBreadcrumbs(routes);

    return (
        <div className={s.breadcrumbs}>
            {breadcrumbs.map(({
                                  match,
                                  breadcrumb
                              }, index) => (
                <span key={match.pathname}>
          <NavLink to={match.pathname}>{breadcrumb}{index == breadcrumbs.length - 1 ? null : "/"}</NavLink>
        </span>
            ))}

        </div>
    )

}

export default Breadcrumbs;